import Vue from 'vue'
import Vuex from 'vuex'
import storejs from 'storejs'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)
// 应用初始状态
const state = {
	UPDATE_DIRECTION:'',
	ROUTER_HISTORY:'',
	USER_OPTIONS:{
		TOKEN:'',
		OPENID:'',
	},

	CHOSE_CAR:{
		CAR_BRAND:'',
		CAR_MODEL:'',
		CAR_DISPLACEMENT:'',
		CAR_YEAR:'',
		CAR_INFO:''
	},
	CHOSE_PARTS:{
		SERVICESPARAMS:'',//获得所有数据传的参数
		GROUPSERVICES:''//所有的数据
	},
	ORDER_INFO:[],
	CITY_OPTION:{},
	ADDRESS_OPTION:{}

}
// 定义所需的 mutations
const mutations = {
	[actions.UPDATE_DIRECTION]:(state,val)=>{
		state.UPDATE_DIRECTION=val;
	},

	[actions.ROUTER_HISTORY]:(state,val) => {
		state.ROUTER_HISTORY=val;
		localStorage.setItem('routerHistroy',val)
	},
	//注销登录
	[actions.LOGOUT]:(state)=>{
		state.USER_OPTIONS.TOKEN='';
		state.USER_OPTIONS.OPENID='';
		var vm = new Vue();
		vm.delCookie('token');
		vm =null;

	},
	//正常登录
	[actions.LOGIN]:(state,val)=>{
		state.USER_OPTIONS.TOKEN=val;
		var vm = new Vue();
        vm.setCookie('token',val);
        vm=null;
	},

	//保存配件
	[actions.SAVE_PARTS](state, parts) {
		state.parts = parts;
		localStorage.setItem('parts', JSON.stringify(parts));
	},
	//保存订单信息
	[actions.SAVE_ORDERINFO](state, orderInfo) {
		state.ORDER_INFO=orderInfo;
		let orderInfoString=[];
		for(let i = 0,l=orderInfo.length;i<l;i++){
			orderInfoString.push(JSON.stringify(orderInfo[i]));
		}
		localStorage.setItem('orderInfo', orderInfoString.join("@"));
	},
	//车的信息
	[actions.SAVE_CAR_INFO](state,val){
		state.CAR_INFO=val;
		localStorage.setItem('carInfo',JSON.stringify(val));
	},
	//车的品牌
	[actions.CAR_BRAND](state,val) {
		state.CHOSE_CAR.CAR_BRAND=val;
		localStorage.setItem('carBrand',JSON.stringify(val))

	},
	//车的类型
    [actions.CAR_MODEL] (state,val) {
		state.CHOSE_CAR.CAR_MODEL=val;
		localStorage.setItem('carModel',JSON.stringify(val));

    },
	//车的排量
    [actions.CAR_DISPLACEMENT](state,val) {
		state.CHOSE_CAR.CAR_DISPLACEMENT=val;
		localStorage.setItem('carDisplacement',JSON.stringify(val));
    },
	//车的生产年份
    [actions.CAR_YEAR](state,val) {
		state.CHOSE_CAR.CAR_YEAR=val;
		localStorage.setItem('carYear',JSON.stringify(val));
    },
	//车的信息
    [actions.CAR_INFO](state,val) {
		state.CHOSE_CAR.CAR_INFO=val;
		localStorage.setItem('carInfo',JSON.stringify(val));
    },
    //保存城市
    [actions.SAVE_CITY](state,val) {
    	state.CITY_OPTION=val;
    	localStorage.setItem('cityOption', val)
    },
	/*
	 * 配件选择和替换
	 */
	[actions.SAVE_SERVICESPARAMS](state,val){
		state.CHOSE_PARTS.SERVICESPARAMS=val;
		localStorage.setItem('servicesParams',val);
	},
    //保存所有的配件
    [actions.SAVE_GROUPSERVICES](state,val) {
    	state.CHOSE_PARTS.GROUPSERVICES =val;
    	localStorage.setItem('groupServices',val);
    },
    //保存被替换配件的父级的ID
	[actions.SAVE_CHOSEPID](state,val) {
        state.CHOSE_PARTS.CHOSEPID=val;
        localStorage.setItem('pId',val);
    },
    //已选择的服务ID
    [actions.SAVE_SERVICESID](state,val) {
    	localStorage.setItem('saveServicesId',val);
    },
    //保存被替换的配件
    [actions.SAVE_CHOSEPARTS](state,val,pId) {
        state.CHOSE_PARTS.CHOSEPARTS=val;
        localStorage.setItem('choseParts',JSON.stringify(val));

    },
    //保存需要替换的配件
    [actions.SAVE_REPLACEPARTS](state,val) {
        state.CHOSE_PARTS.REPLACEPARTS=val;
        localStorage.setItem('replaceParts',JSON.stringify(val));
    },
    //保存地址
    [actions.SAVE_ADDRESS](state,val) {
    	state.ADDRESS_OPTION=val;
    	window.sessionStorage.setItem('addressOption',val);
    },
	//保存虚拟门店
	[actions.SAVE_VSHOP](state,val) {
		state.VSHOP_OPTION=val;
		localStorage.setItem('vshopOption',val);
	}
}
// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js